
export const data = [
    {
      "tipo_mapa": "puntos",
      "puntos": [





        //POLITICO

        {
          "id": "1",
          "suceso": "POLITICO",
          "puntos": {
            "lat": "5.33671",
            "lng": "-72.39532"
          }
        },
        {
          "id": "2",
          "suceso": "POLITICO",
          "puntos": {
            "lat": "6.79810",
            "lng": "-71.77046"
          }
        },
        {
          "id": "3",
          "suceso": "POLITICO",
          "puntos": {
            "lat": "6.95405",
            "lng": "-71.87487"
          }
        },
        {
          "id": "4",
          "suceso": "POLITICO",
          "puntos": {
            "lat": "6.45948",
            "lng": "-71.74148"
          }
        },
      

        //SOCIAL

        {
          "id": "1",
          "suceso": "SOCIAL",
          "puntos": {
            "lat": "6.15780",
            "lng": "-71.76374"
          }
        },
        {
          "id": "2",
          "suceso": "SOCIAL",
          "puntos": {
            "lat": "5.33671",
            "lng": "-72.39532"
          }
        },
       


        //ECONOMICO

        {
          "id": "1",
          "suceso": "ECONOMICO",
          "puntos": {
            "lat": "4.87846",
            "lng": "-72.89455"
          }
        },
        {
          "id": "2",
          "suceso": "ECONOMICO",
          "puntos": {
            "lat": "6.95405",
            "lng": "-71.87487"
          }
        },
        {
          "id": "3",
          "suceso": "ECONOMICO",
          "puntos": {
            "lat": "7.07684",
            "lng": "-70.75432"
          }
        },
        {
          "id": "4",
          "suceso": "ECONOMICO",
          "puntos": {
            "lat": "5.33671",
            "lng": "-72.39532"
          }
        },





        //AMENAZAS

        {
          "id": "1",
          "suceso": "FUERZA",
          "nombre": "GMGDC",
          "puntos": {
            "lat": "5.01649",
            "lng": "-72.75040"
          }
        },
        {
          "id": "2",
          "suceso": "FUERZA",
          "nombre": "GMGDC",
          "puntos": {
            "lat": "7.07684",
            "lng": "-70.75432"
          }
        },
        {
          "id": "3",
          "suceso": "FUERZA",
          "nombre": "GMGDC",
          "puntos": {
            "lat": "5.72913",
            "lng": "-71.99278"
          }
        },
        {
          "id": "4",
          "suceso": "FUERZA",
          "nombre": "GMGDC",
          "puntos": {
            "lat": "6.50939",
            "lng": "-71.41231"
          }
        },
        {
          "id": "5",
          "suceso": "FUERZA",
          "nombre": "GMGDC",
          "puntos": {
            "lat": "4.09409",
            "lng": "-72.95961"
          }
        },








        {
          "id": "1",
          "suceso": "AMENAZA",
          "puntos": {
            "lat": "6.95405",
            "lng": "-71.87487"
          }
        },
        {
          "id": "2",
          "suceso": "AMENAZA",
          "puntos": {
            "lat": "6.95405",
            "lng": "-71.87487"
          }
        },
        {
          "id": "3",
          "suceso": "AMENAZA",
          "puntos": {
            "lat": "6.45948",
            "lng": "-71.74148"
          }
        },
        {
          "id": "4",
          "suceso": "AMENAZA",
          "puntos": {
            "lat": "6.52621",
            "lng": "-71.50056"
          }
        },
        {
          "id": "5",
          "suceso": "AMENAZA",
          "puntos": {
            "lat": "6.45948",
            "lng": "-71.74148"
          }
        },
        {
          "id": "6",
          "suceso": "AMENAZA",
          "puntos": {
            "lat": "6.63304",
            "lng": "-71.61082"
          }
        },
        {
          "id": "7",
          "suceso": "AMENAZA",
          "puntos": {
            "lat": "6.45948",
            "lng": "-71.74148"
          }
        },
        {
          "id": "8",
          "suceso": "AMENAZA",
          "puntos": {
            "lat": "6.45948",
            "lng": "-71.74148"
          }
        },
        {
          "id": "9",
          "suceso": "AMENAZA",
          "puntos": {
            "lat": "6.81326",
            "lng": "-71.75299"
          }
        },
        {
          "id": "10",
          "suceso": "AMENAZA",
          "puntos": {
            "lat": "6.81326",
            "lng": "-71.34778"
          }
        },
        // {
        //   "id": "2",
        //   "suceso": "AMENAZA",
        //   "puntos": {
        //     "lat": "6.97104",
        //     "lng": "-71.94747"
        //   }
        // },
        // {
        //   "id": "3",
        //   "suceso": "AMENAZA",
        //   "puntos": {
        //     "lat": "6.95375",
        //     "lng": "-71.87321"
        //   }
        // },
        // {
        //   "id": "4",
        //   "suceso": "AMENAZA",
        //   "puntos": {
        //     "lat": "6.95685",
        //     "lng": "-71.85046"
        //   }
        // },
        // {
        //   "id": "5",
        //   "suceso": "AMENAZA",
        //   "puntos": {
        //     "lat": "6.46116",
        //     "lng": "-71.73171"
        //   }
        // },
        // {
        //   "id": "6",
        //   "suceso": "AMENAZA",
        //   "puntos": {
        //     "lat": "6.96741",
        //     "lng": "-71.92443"
        //   }
        // },
        // {
        //   "id": "7",
        //   "suceso": "AMENAZA",
        //   "puntos": {
        //     "lat": "6.96941",
        //     "lng": "-71.67645"
        //   }
        // },
        // {
        //   "id": "8",
        //   "suceso": "AMENAZA",
        //   "puntos": {
        //     "lat": "6.73951",
        //     "lng": "-71.7113"
        //   }
        // },
        // {
        //   "id": "9",
        //   "suceso": "AMENAZA",
        //   "puntos": {
        //     "lat": "6.95685",
        //     "lng": "-71.85046"
        //   }
        // },
        // {
        //   "id": "10",
        //   "suceso": "AMENAZA",
        //   "puntos": {
        //     "lat": "6.78112",
        //     "lng": "-70.76165"
        //   }
        // },
        // {
        //   "id": "11 ",
        //   "suceso": "AMENAZA",
        //   "puntos": {
        //     "lat": "6.22899",
        //     "lng": "-71.61428"
        //   }
        // }



        // ,
        // {
        //   "id": "12",
        //   "suceso": "AMENAZA",
        //   "puntos": {
        //     "lat": "6.22899",
        //     "lng": "-71.61428"
        //   }
        // },
        // {
        //   "id": "13",
        //   "suceso": "AMENAZA",
        //   "puntos": {
        //     "lat": "6.99133",
        //     "lng": "-71.90877"
        //   }
        // },
        // {
        //   "id": "14",
        //   "suceso": "AMENAZA",
        //   "puntos": {
        //     "lat": "6,79264",
        //     "lng": "-71.77404"
        //   }
        // }
      ]
    },

    //ZONAS COBERTURA FUERZA DISPONIBLE

    // {
    //   "tipo_mapa": "poligono_fuerza",
    //   "nombre": "Cobertura fuerza disponible GMGDC16 ",
    //   "color": "#e3c500",
    //   "opacidad" : 0.6,
    //   "puntos" : "-72.29069121651123,5.398320584488886 -72.18726202652962,5.4001107035474964 -71.9037778028933,5.622258885985798 -71.79923256056351,5.9336954368713135 -71.5975624828469,6.211593866760381 -71.68964715552845,6.208054751098266 -71.81349926056298,6.04883892324414 -71.83055830289149,5.986321702297685 -71.8844503740559,5.940500076287135 -71.93567341638521,5.719627828912638 -72.20358778940192,5.447868082051641 -72.29886827479328,5.454238973778093"
    // },


    // {
    //   "tipo_mapa": "poligono_fuerza",
    //   "nombre": "Cobertura fuerza disponible BAEEV 22 ",
    //   "color": "#e3c500",
    //   "opacidad" : 0.7,
    //   "puntos" : "-71.60200456015541,6.2386705281330785 -71.63787689382968,6.240111082361493 -71.64058264292049,6.211838126450723 -71.6329697822672,6.20688180371691"
    // },

    // {
    //   "tipo_mapa": "poligono_fuerza",
    //   "nombre": "Cobertura fuerza disponible BIRAN 18 ",
    //   "color": "#e3c500",
    //   "opacidad" : 0.7,
    //   "puntos" : "-71.6020948740543,6.23924766<2417234 -71.65692854521802,6.300125868449439 -71.6734639028894,6.384153966105337 -71.65681353172509,6.40310999548317 -71.64420401823249,6.459486892072203 -71.68166110288773,6.662474222877373 -71.70500158939541,6.670674219306482 -71.71108094001667,6.642312355869886 -71.67230206056068,6.458751231683145 -71.67848461823262,6.415136305212959 -71.69728611054731,6.388391696632829 -71.67819963172582,6.294212407079337 -71.63782463172612,6.240459631291087"
    // },


    // {
    //   "tipo_mapa": "poligono_fuerza",
    //   "nombre": "Cobertura fuerza disponible BAEEV 14",
    //   "color": "#e3c500",
    //   "opacidad" : 0.9,
    //   "puntos" : "-71.68166073172354,6.662848779093389 -71.67624366055922,6.719864018335642 -71.77762322472779,6.945679191064521 -71.806918660558,6.91858196000579 -71.79956600936084,6.841972998826703 -71.70493853172354,6.6712529438410195"
    // },

    // {
    //   "tipo_mapa": "poligono_fuerza",
    //   "nombre": "Cobertura fuerza disponible GMRPI18",
    //   "color": "#e3c500",
    //   "opacidad" : 0.9,
    //   "puntos" : "-71.77780998939369,6.946213897150305 -71.80840560288603,6.955053242444072 -71.82100718939381,6.932158404791648 -71.80693610288628,6.918683861387397"
    // },







    

    
    // {
    //   "tipo_mapa": "poligono",
    //   "nombre": "ANI",
    //   "color": "#005ce6",
    //   "opacidad" : 0.6,
    //   "puntos" : "-71.62469420,6.46644254 -71.47637877,6.54830913 -71.80047545,6.98470019 -71.88836608,6.95471104 -71.92132506,6.949258261 -71.94055114,6.92744652 -71.62469420,6.46644254"
    // },

    // {
    //   "tipo_mapa": "poligono",
    //   "nombre": "Area de influencia de la compañia Saravena de la Subestructura 10 del GAOR-FARC",
    //   "color": "#f50000",
    //   "opacidad" : 0.3,
    //   "puntos" : "-72.003619846477,6.815726479424 -71.93358200468,6.8198172197523 -71.853931125773,6.8361798315704 -71.695407206173,6.8920811873329 -71.674807840938,6.9029880020058 -71.673434549923,6.9438863152265 -71.718753153438,7.0011379764032 -71.832736307735,7.028398206728 -71.873935038204,7.0120422600164 -71.987918192501,6.9629709793101 -72.031863505001,6.9466127432612 -72.052462870235,6.9111679480805 -72.057956034298,6.8675399373224 -72.07306223547,6.8389068791139 -72.031863505001,6.8061812829387 -72.003619846477,6.815726479424"
    // },

    // {
    //   "tipo_mapa": "poligono",
    //   "nombre": "Area de influencia de la compañia Fortul de la Subestructura 10 del GAOR-FARC",
    //   "color": "#f50000",
    //   "opacidad" : 0.3,
    //   "puntos" : "-71.858029023018,6.6447118396771 -71.781124726143,6.6651724081979 -71.68774093708,6.7088187642534 -71.571011200752,6.767462392569 -71.558651581611,6.8124631408693 -71.562771454658,6.8479153036843 -71.62182296833,6.8710941405853 -71.671261444893,6.8942718476079 -71.70971359333,6.8969985622132 -71.752285614815,6.8670038395981 -71.79760421833,6.8588231321464 -71.82918991169,6.8260988989876 -71.840176239815,6.797463359188 -71.862148896065,6.7715535434276 -71.881374970283,6.744278550176 -71.89510788044,6.7115465319202 -71.893734589424,6.6733563966904 -71.881374970283,6.6474399647171"
    // },

    // {
    //   "tipo_mapa": "poligono",
    //   "nombre": "Area de influencia de la compañia Uriel Londoño del GAOR-FARC subestructura 10",
    //   "color": "#f50000",
    //   "opacidad" : 0.3,
    //   "puntos" : "-71.922476060672,6.2734681737476 -71.796133287235,6.3034987874758 -71.664297349735,6.3417170530254 -71.595632798954,6.3908506578605 -71.504995591922,6.4099568984362 -71.322771072187,6.4454380161303 -71.322771072187,6.5245792377466 -71.374956130781,6.5655094567149 -71.385942458906,6.5927944011999 -71.407915115156,6.630990799337 -71.451860427656,6.6528159846597 -71.484819412031,6.6610001793357 -71.561723708906,6.6255343518647 -71.613908767499,6.650087889458 -71.671586990156,6.630990799337 -71.764970779218,6.6064363107045 -71.852861404218,6.5627808799106 -71.910539626874,6.5382230166837 -71.946245193281,6.4891036753457 -72.001176833906,6.4290624232621 -72.009416579999,6.3089587125109 -72.017656326093,6.2707380320248 -71.970964431562,6.246166113978"
    // },

    // {
    //   "tipo_mapa": "poligono",
    //   "nombre": "Area de influencia de la Subestructura-28 GAOR-FARC",
    //   "color": "#f50000",
    //   "opacidad" : 0.3,
    //   "puntos" : "-72.365584619802,5.2547863468762 -72.195296533865,5.3641782315526 -72.046981104177,5.5309629720816 -71.956343897146,5.6485043830544 -71.849227197927,5.779685207467 -71.797042139334,5.9299591692821 -71.742110498709,6.1020408115582 -71.703658350271,6.189426303532 -71.824507959646,6.2303832904573 -71.879439600271,6.2221921480914 -72.063460596365,5.9326910474013 -72.176070459646,5.8070107440454 -72.329879053396,5.5665012277675 -72.458968408865,5.4380066883392 -72.497420557302,5.3340973959288 -72.458968408865,5.2547863416595"
    // },
    
    {
      "tipo_mapa": "poligono",
      "color" : "#ff8645",
      "puntos" : "-69.92316437,6.05792284 -69.92910004,6.06719923 -69.9355011,6.07470179 -69.94059753,6.0788002 -69.95800018,6.09789896 -69.9815979,6.10550022 -70.0,6.11019993 -70.00810242,6.10679913 -70.0306015,6.10580111 -70.04560089,6.10580111 -70.05480194,6.10820103 -70.05709839,6.12030077 -70.0582962,6.13530016 -70.07499695,6.15210009 -70.08709717,6.16720104 -70.11190033,6.17889977 -70.13330078,6.20320177 -70.15859985,6.21950006 -70.16790009,6.24030018 -70.17250061,6.24790096 -70.18229675,6.24850178 -70.18569946,6.24330091 -70.20069885,6.24390078 -70.20880127,6.24630117 -70.23699951,6.24579906 -70.25779724,6.24359989 -70.27279663,6.24020004 -70.2940979,6.23910093 -70.33159637,6.24220085 -70.354599,6.24570084 -70.36789703,6.24579906 -70.39730072,6.24480104 -70.41290283,6.24480104 -70.41799927,6.2420001 -70.43710327,6.2420001 -70.44689941,6.24209976 -70.45780182,6.23060179 -70.46700287,6.22540092 -70.4803009,6.22489977 -70.49069977,6.22380114 -70.498703,6.21630096 -70.50330353,6.2111001 -70.51080322,6.2060008 -70.51599884,6.2060008 -70.52929687,6.21410084 -70.53849792,6.20200109 -70.54949951,6.20440102 -70.56040192,6.20559978 -70.57369995,6.20389986 -70.58809662,6.204 -70.61000061,6.19770002 -70.62270355,6.1960001 -70.64170074,6.19089985 -70.66880035,6.18810081 -70.68779755,6.18650103 -70.70680237,6.19060087 -70.71369934,6.19119978 -70.72350311,6.19130087 -70.73680115,6.19130087 -70.75009918,6.191401 -70.76329803,6.19079924 -70.77429962,6.19150114 -70.78179932,6.19610119 -70.79499817,6.20480013 -70.81349945,6.20489979 -70.82610321,6.20090008 -70.83589935,6.19920015 -70.85150146,6.19929981 -70.8687973,6.1994009 -70.88030243,6.18839884 -70.89649963,6.18450022 -70.90399933,6.18450022 -70.91609955,6.1862998 -70.9292984,6.19150114 -70.9598999,6.19460106 -70.97309875,6.19579983 -70.99510193,6.20160007 -71.01869965,6.21269894 -71.03019714,6.2203002 -71.04920197,6.22090006 -71.06310272,6.22209883 -71.08329773,6.22399902 -71.1006012,6.22919989 -71.12359619,6.22930098 -71.13510132,6.22710085 -71.14900208,6.22600079 -71.16280365,6.22950077 -71.16860199,6.23640013 -71.18360138,6.23710012 -71.20429993,6.24289989 -71.2233963,6.25050116 -71.23660278,6.24770021 -71.23829651,6.24599981 -71.23950195,6.24139786 -71.24990082,6.23039913 -71.25789642,6.23050022 -71.26999664,6.23280096 -71.28099823,6.23520088 -71.28559875,6.2322998 -71.29139709,6.22660017 -71.30059814,6.22950077 -71.31099701,6.23010111 -71.3184967,6.22900009 -71.33799744,6.21460009 -71.34780121,6.20889997 -71.36049652,6.20370102 -71.37439728,6.19920015 -71.38420105,6.19920015 -71.38990021,6.19920015 -71.3934021,6.20160007 -71.40090179,6.20680094 -71.41590118,6.20340109 -71.42160034,6.20110083 -71.42739868,6.20110083 -71.43080139,6.20060015 -71.44120026,6.19659996 -71.4464035,6.19720078 -71.4539032,6.20410013 -71.45970154,6.1967001 -71.45970154,6.19199991 -71.46600342,6.18509912 -71.4815979,6.17709923 -71.49649811,6.17600107 -71.51100159,6.17659998 -71.51959991,6.16800117 -71.53630066,6.16979885 -71.54840088,6.17799997 -71.55819702,6.17679882 -71.5605011,6.16880083 -71.56459808,6.16529989 -71.58010101,6.1717 -71.58529663,6.17409992 -71.58989716,6.16950083 -71.5951004,6.16489887 -71.60900116,6.17070007 -71.61470032,6.17479992 -71.62909698,6.18750095 -71.64589691,6.19399881 -71.66490173,6.20040083 -71.68509674,6.19990015 -71.70639801,6.1960001 -71.73120117,6.19199991 -71.74790192,6.18690014 -71.77149963,6.18180084 -71.79049683,6.17549896 -71.79799652,6.17320013 -71.81759644,6.16289997 -71.82969666,6.15030098 -71.83840179,6.14050102 -71.84760284,6.13700008 -71.85679626,6.13539982 -71.91500092,6.12979984 -71.93520355,6.13110018 -71.95249939,6.13400078 -71.96350098,6.13059998 -71.97090149,6.12770081 -71.98020172,6.12030077 -71.98999786,6.11569881 -72.00029755,6.11170006 -72.01239777,6.1065011 -72.02400208,6.10370016 -72.03949738,6.10090113 -72.04989624,6.09800005 -72.07530212,6.09180021 -72.0891037,6.08549881 -72.10119629,6.07399988 -72.10639954,6.07110119 -72.11160278,6.06650019 -72.123703,6.05389786 -72.13110352,6.04699898 -72.13809967,6.04300022 -72.14559937,6.04010105 -72.15070343,6.04010105 -72.15879822,6.04190111 -72.17269897,6.04949999 -72.1882019,6.05470085 -72.20549774,6.06059885 -72.22740173,6.07340097 -72.24240112,6.08209991 -72.26260376,6.09139919 -72.27929687,6.09610081 -72.28800201,6.10829878 -72.29260254,6.11470079 -72.30410004,6.12680101 -72.30870056,6.13609982 -72.30989838,6.14879894 -72.30760193,6.16150093 -72.30930328,6.16670179 -72.31220245,6.17309904 -72.33070374,6.17949915 -72.34449768,6.18010092 -72.36470032,6.18200016 -72.38140106,6.18029881 -72.39579773,6.18610001 -72.40329742,6.2104001 -72.41950226,6.22669983 -72.42060089,6.23999882 -72.42238617,6.24374819 -72.41600037,6.25610113 -72.40799713,6.27050114 -72.39759827,6.28379917 -72.39360046,6.29530001 -72.38259888,6.30620098 -72.37229919,6.31829882 -72.35839844,6.32859993 -72.35559845,6.32919979 -72.34919739,6.3314991 -72.33190155,6.34240103 -72.32499695,6.34410095 -72.31664276,6.35310602 -72.31349945,6.36600113 -72.31349945,6.3828001 -72.31700134,6.39319992 -72.31700134,6.40530014 -72.31700134,6.41569996 -72.30950165,6.42140007 -72.30490112,6.42030096 -72.3003006,6.41789913 -72.27950287,6.41090012 -72.27030182,6.41090012 -72.25990295,6.41079998 -72.2437973,6.4124999 -72.23110199,6.41299915 -72.22129822,6.42109919 -72.20290375,6.43659878 -72.19190216,6.44459915 -72.17690277,6.46019983 -72.16539764,6.47340107 -72.16079712,6.4843998 -72.15619659,6.49700117 -72.15450287,6.5138011 -72.1516037,6.53459978 -72.14759827,6.55420113 -72.14589691,6.57559919 -72.14070129,6.59689999 -72.1332016,6.61709976 -72.12799835,6.63270092 -72.11940002,6.64820099 -72.10839844,6.66029882 -72.10099792,6.67240095 -72.09870148,6.67880106 -72.09120178,6.69369984 -72.08480072,6.70580006 -72.07790375,6.72139978 -72.0727005,6.73060083 -72.06580353,6.74329996 -72.06300354,6.75140095 -72.05549622,6.76639986 -72.0542984,6.77790022 -72.04859924,6.79809999 -72.04740143,6.80730104 -72.04450226,6.81770086 -72.03710175,6.83039999 -72.03420258,6.84429979 -72.02899933,6.85459995 -72.020401,6.868999 -72.01519775,6.88870001 -72.00370026,6.89839983 -71.98308563,7.01027822 -71.96712494,7.00863504 -71.95975494,7.01018715 -71.93907166,7.01026678 -71.9209137,7.01059294 -71.90480042,7.0141511 -71.8735733,7.00909615 -71.84622192,7.00866508 -71.84048462,7.00770283 -71.83310699,7.01132488 -71.82221985,7.02296019 -71.82396698,7.03698778 -71.82034302,7.04574394 -71.81723022,7.04757023 -71.81305695,7.04627991 -71.80864716,7.04812288 -71.80440521,7.05519295 -71.80166626,7.05746794 -71.79876709,7.05409718 -71.79602051,7.05658388 -71.79263306,7.06177998 -71.78923798,7.06718397 -71.78692627,7.06883621 -71.78261566,7.05876493 -71.78160095,7.05520201 -71.77848053,7.05287504 -71.77425385,7.05785513 -71.76787567,7.07013321 -71.7638855,7.07197905 -71.76012421,7.07173777 -71.75954437,7.06629992 -71.76066589,7.05690002 -71.75987244,7.05187702 -71.75884247,7.04977798 -71.75485992,7.05037117 -71.74516296,7.05969191 -71.73991394,7.06194592 -71.73447418,7.0616889 -71.73262787,7.05790997 -71.7292099,7.04115582 -71.72692871,7.03862906 -71.72511292,7.03767586 -71.71963501,7.03480196 -71.71879578,7.0356288 -71.70142365,7.03652477 -71.69975281,7.03629923 -71.69618988,7.03731394 -71.68718719,7.03744078 -71.67926025,7.03549004 -71.66514587,7.02177906 -71.66326904,7.0211339 -71.6601181,7.02235985 -71.65961456,7.03301477 -71.66098785,7.04348278 -71.65949249,7.04764891 -71.65569305,7.05116796 -71.65087891,7.05133486 -71.6456604,7.04806423 -71.64001465,7.04639101 -71.63018036,7.03965378 -71.62526703,7.03881979 -71.62168121,7.03821182 -71.61546326,7.04000092 -71.60391235,7.04772186 -71.59703064,7.04675102 -71.59315491,7.04166698 -71.59348297,7.02834511 -71.59008789,7.02073479 -71.57859802,7.02041817 -71.57053375,7.02357006 -71.55846405,7.02780724 -71.55324554,7.0296402 -71.54016876,7.02701187 -71.5256958,7.02528906 -71.50684357,7.02651978 -71.49152374,7.01514196 -71.47786713,7.02836084 -71.47210693,7.02992487 -71.46938324,7.02576685 -71.46627045,7.01103687 -71.46373749,7.01124716 -71.45866394,7.01419401 -71.44274902,7.02096081 -71.43740082,7.03010893 -71.43279266,7.03144884 -71.42105865,7.03319502 -71.40428162,7.03214216 -71.39442444,7.02907896 -71.38848114,7.024436 -71.38506317,7.02004194 -71.3809433,7.01794291 -71.36785889,7.01577091 -71.34557343,7.01444197 -71.33018494,7.01247978 -71.32235718,7.01471615 -71.31612396,7.01834011 -71.30461121,7.02146387 -71.28942871,7.02271986 -71.28089142,7.02678585 -71.27955627,7.02697515 -71.27169037,7.02809 -71.25111389,7.01299095 -71.24330139,7.01292515 -71.23428345,7.01974392 -71.22692108,7.02129078 -71.21199799,7.01910114 -71.18624878,7.0198102 -71.1680603,7.02356577 -71.15745544,7.02754307 -71.15307617,7.02918577 -71.13951874,7.02907181 -71.13310242,7.02603197 -71.1281662,7.01013899 -71.11508179,7.00865078 -71.1086731,7.00446177 -71.11698914,6.99924707 -71.11380768,6.99462795 -71.10421753,6.98673677 -71.09297943,6.98319483 -71.08562469,6.98313379 -71.06586456,6.98296785 -71.01555634,6.97910023 -71.00771332,6.98409605 -70.99384308,6.99293184 -70.98715973,6.99494219 -70.98257446,6.99352503 -70.97118378,6.98148203 -70.96291351,6.9802618 -70.95877075,6.98137379 -70.95298767,6.98592091 -70.9436264,7.00720787 -70.93113708,7.01675081 -70.92669678,7.02544403 -70.91568756,7.02259302 -70.91381836,7.02671099 -70.9020462,7.03304482 -70.90039825,7.03762579 -70.90258789,7.05188894 -70.89702606,7.05735397 -70.88782501,7.05796289 -70.88783264,7.0568161 -70.87657928,7.0560298 -70.8671875,7.05181313 -70.859375,7.05128717 -70.85705566,7.05402184 -70.85140228,7.07097578 -70.83854675,7.0687952 -70.82936096,7.06756878 -70.80952454,7.0756669 -70.80399323,7.07791424 -70.79502106,7.07875681 -70.78883362,7.07640314 -70.78171539,7.07519484 -70.77223206,7.08223295 -70.76605988,7.0859499 -70.7620697,7.08834791 -70.75494385,7.08851385 -70.75101471,7.0874548 -70.73912048,7.08424091 -70.71678925,7.08749104 -70.70162201,7.08735704 -70.69146729,7.09255123 -70.68779755,7.09090996 -70.66744232,7.07901478 -70.65805054,7.07525396 -70.64615631,7.06756878 -70.63745117,7.06427288 -70.61423492,7.06452608 -70.59952545,7.06416607 -70.5912323,7.06638813 -70.5856781,7.0704751 -70.57437897,7.07496881 -70.56079865,7.07691383 -70.54776764,7.06806612 -70.54096985,7.05651808 -70.53993225,7.043643 -70.53423309,7.03784895 -70.52140045,7.0333662 -70.51548004,7.02665186 -70.513237,7.02042723 -70.508255,7.01165295 -70.49957275,7.00536919 -70.48855591,7.00389194 -70.48124695,6.99854279 -70.47229767,6.99639177 -70.46048737,7.00662279 -70.45658112,7.00658894 -70.45154572,7.00447321 -70.4414444,7.00254488 -70.43778992,6.999753 -70.43235016,6.99097395 -70.4257431,6.98425102 -70.41316986,6.98169613 -70.41036224,6.98251581 -70.40618134,6.98247099 -70.40263367,6.98118114 -70.39342499,6.9821291 -70.38694763,6.98143578 -70.37966156,6.97759581 -70.3751297,6.97085905 -70.37328339,6.96728706 -70.36932373,6.96536398 -70.36807251,6.96513987 -70.36669159,6.95676422 -70.36104584,6.95649481 -70.35150146,6.948452 -70.33840942,6.94016123 -70.32778931,6.93566179 -70.31903076,6.93285179 -70.30982971,6.93254423 -70.30144501,6.93454695 -70.28988647,6.93923283 -70.27566528,6.93929195 -70.27062988,6.94070292 -70.26348114,6.9445982 -70.25206757,6.95597601 -70.2432251,6.96152782 -70.23690033,6.96668482 -70.22241211,6.97196817 -70.21655273,6.97211695 -70.20065308,6.9723649 -70.19248962,6.97290277 -70.18852234,6.9722352 -70.18641663,6.97304916 -70.17804718,6.97358704 -70.1692276,6.97683716 -70.15391541,6.98106384 -70.14555359,6.98034716 -70.13658905,6.97711515 -70.12947845,6.97724724 -70.12191772,6.98051119 -70.11984253,6.98296785 -70.10871124,6.9930048 -70.09414673,7.00205517 -70.08931732,7.00246811 -70.08268738,6.99826717 -70.07112885,6.98069477 -70.03617859,6.93141985 -70.03525543,6.93141413 -70.0302887,6.92171383 -70.0246048,6.91522694 -70.01190186,6.8969512 -70.0,6.881001 -69.9942627,6.87640381 -69.98057556,6.85998487 -69.9731369,6.84969711 -69.96151733,6.83507395 -69.95615387,6.82591915 -69.93848419,6.80237293 -69.93173218,6.79230881 -69.89661407,6.74291515 -69.89241028,6.7349 -69.88474274,6.72529984 -69.87497711,6.71180677 -69.85521698,6.68482685 -69.84172821,6.66561413 -69.81057739,6.62238979 -69.79964447,6.60591602 -69.78779602,6.59036779 -69.78104401,6.57960796 -69.77547455,6.5732131 -69.76570129,6.55833721 -69.75315094,6.54099989 -69.75245667,6.54004002 -69.72548676,6.50206518 -69.71943665,6.491992 -69.70874786,6.47804117 -69.69735718,6.46156979 -69.68900299,6.45151186 -69.68364716,6.44281197 -69.6741333,6.43115187 -69.6676178,6.4201622 -69.63624573,6.37646389 -69.61207581,6.34191084 -69.60115814,6.32680893 -69.58187866,6.2995801 -69.54911804,6.25335217 -69.54238892,6.24512196 -69.53401947,6.23230219 -69.53304291,6.23097801 -69.53067017,6.22776699 -69.51660919,6.20873404 -69.49756622,6.18264723 -69.45236969,6.11945486 -69.45042419,6.11673594 -69.44788361,6.11445284 -69.44143677,6.11288881 -69.43656921,6.11511803 -69.43656921,6.10824394 -69.44244385,6.0827961 -69.44244385,6.06579304 -69.44779968,6.0559001 -69.45179749,6.05130005 -69.45179749,6.04040098 -69.45760345,6.03290081 -69.47019958,6.03060102 -69.48059845,6.02199984 -69.4897995,6.02259922 -69.52100372,6.02040005 -69.54170227,6.01760101 -69.56359863,6.00730085 -69.59069824,6.00169897 -69.60679626,5.99250078 -69.6230011,5.98850107 -69.63220215,5.98909998 -69.65529633,5.9914999 -69.67949677,5.99340105 -69.69560242,5.99289989 -69.71289825,5.99119902 -69.73880005,5.99820089 -69.77059937,6.00530005 -69.78379822,6.00880098 -69.79419708,6.0048008 -69.80570221,6.00029993 -69.8207016,6.00210094 -69.84609985,6.00909996 -69.84786987,6.00488091 -69.85179901,6.00449991 -69.8588028,6.00509977 -69.87200165,6.00689983 -69.88179779,6.00689983 -69.89559937,6.01050091 -69.90429687,6.01280117 -69.91120148,6.0163002 -69.91529846,6.02560091 -69.91870117,6.03480196 -69.92099762,6.04980087 -69.91760254,6.05620003 -69.92316437,6.05792284"
    },
    {
      "tipo_mapa": "poligono",
      "color": "#dbb93d",
      "puntos": "-72.63629913,4.28270006 -72.64550018,4.27869987 -72.65529633,4.27530003 -72.67140198,4.27359915 -72.68579865,4.27370024 -72.70079803,4.27139997 -72.71060181,4.27029896 -72.71469879,4.26629877 -72.72100067,4.26050091 -72.72499847,4.2473011 -72.73139954,4.24669886 -72.74690247,4.25310087 -72.75669861,4.26179981 -72.7677002,4.26590109 -72.76999664,4.27980089 -72.771698,4.28790092 -72.77290344,4.29369879 -72.78099823,4.30530024 -72.79190063,4.31280088 -72.80169678,4.31399918 -72.80860138,4.31689787 -72.813797,4.32330084 -72.80809784,4.33080101 -72.8167038,4.34180021 -72.82360077,4.34760094 -72.82129669,4.35679913 -72.81330109,4.36550093 -72.82649994,4.37129879 -72.84670258,4.37080002 -72.84960175,4.3730998 -72.84899902,4.38410091 -72.84899902,4.39569998 -72.8588028,4.39860106 -72.86979675,4.39750004 -72.87149811,4.40619993 -72.87149811,4.40959978 -72.87729645,4.41830015 -72.89520264,4.43860006 -72.91770172,4.45889997 -72.93319702,4.47520018 -72.95230103,4.49949789 -72.98059845,4.53540087 -73.00250244,4.56269884 -73.0243988,4.5968008 -73.03710175,4.61880016 -73.04570007,4.63450098 -73.07230377,4.666399 -73.07289886,4.67729998 -73.06770325,4.68710089 -73.06770325,4.69229889 -73.06939697,4.70330095 -73.07810211,4.71430016 -73.07810211,4.71889877 -73.07749939,4.7218008 -73.07980347,4.7317009 -73.08100128,4.74150085 -73.08679962,4.76690006 -73.09889984,4.77850103 -73.09480286,4.78020096 -73.09020233,4.79060078 -73.08679962,4.7981019 -73.08329773,4.80440092 -73.08159637,4.81019878 -73.07640076,4.82579994 -73.0707016,4.83729982 -73.06780243,4.84829903 -73.06430054,4.8633008 -73.05970001,4.88520098 -73.05919647,4.90889883 -73.06089783,4.9204998 -73.04709625,4.95220089 -73.04019928,4.95499897 -73.03150177,4.95729923 -73.02690125,4.95839977 -73.01940155,4.96130085 -73.0102005,4.96360111 -73.0062027,4.9659009 -72.99639893,4.97100115 -72.98829651,4.97389984 -72.97679901,4.98190022 -72.96869659,4.98710108 -72.95829773,4.99510098 -72.94850159,5.00139999 -72.9382019,5.01290083 -72.93552399,5.01439095 -72.93299866,5.0158 -72.93009949,5.02159977 -72.9312973,5.02390003 -72.93470001,5.03720093 -72.93299866,5.04469919 -72.93009949,5.05570078 -72.93360138,5.06260014 -72.94339752,5.06839991 -72.94860077,5.07190084 -72.96530151,5.09050083 -72.9763031,5.10260105 -72.98609924,5.11419916 -72.98200226,5.12750006 -72.97740173,5.14020014 -72.96820068,5.16209984 -72.95839691,5.18110085 -72.95899963,5.18860006 -72.95899963,5.19560099 -72.96250153,5.19960117 -72.96479797,5.20540094 -72.97170258,5.21010113 -72.96130371,5.22100019 -72.95149994,5.22669983 -72.93199921,5.2421999 -72.91290283,5.25950098 -72.8973999,5.2796011 -72.88240051,5.28940105 -72.87030029,5.31129885 -72.86049652,5.32160091 -72.85070038,5.32800102 -72.83170319,5.34120083 -72.82360077,5.34289885 -72.80870056,5.33990002 -72.80120087,5.33010006 -72.78959656,5.32250118 -72.77980042,5.31549883 -72.771698,5.30389881 -72.7602005,5.29180098 -72.75270081,5.27839994 -72.748703,5.27209997 -72.73940277,5.27610016 -72.72619629,5.25470114 -72.72039795,5.24829912 -72.71350098,5.23500013 -72.70939636,5.23610115 -72.70249939,5.24359989 -72.69619751,5.25279999 -72.68990326,5.27070093 -72.68640137,5.28050089 -72.68180084,5.28280115 -72.67549896,5.29030085 -72.67259979,5.30530024 -72.66799927,5.31789923 -72.65529633,5.32540178 -72.646698,5.32770014 -72.63629913,5.32820082 -72.62249756,5.33390093 -72.60800171,5.33959913 -72.59880066,5.3512001 -72.60289764,5.3512001 -72.60340118,5.35459995 -72.59940338,5.36159992 -72.59880066,5.36389923 -72.59829712,5.37020111 -72.59249878,5.37830114 -72.58039856,5.38230085 -72.56600189,5.38910007 -72.54930115,5.40290022 -72.53829956,5.41270018 -72.52619934,5.42539883 -72.51699829,5.43690014 -72.50720215,5.45130014 -72.50150299,5.46400118 -72.48709869,5.47720003 -72.47499847,5.48060179 -72.45999908,5.4927001 -72.45709991,5.49440002 -72.45359802,5.49900007 -72.45249939,5.50190115 -72.45079803,5.51000118 -72.44390106,5.52210093 -72.44039917,5.53070021 -72.43289948,5.53700018 -72.42079926,5.54279995 -72.41619873,5.54269981 -72.40699768,5.5387001 -72.40579987,5.52880192 -72.40119934,5.51960087 -72.39769745,5.51029921 -72.39080048,5.4987011 -72.38159943,5.48950005 -72.37180328,5.48130178 -72.35970306,5.47379923 -72.35449982,5.46509981 -72.34349823,5.46560097 -72.32679749,5.47130108 -72.32109833,5.48689985 -72.32450104,5.49790096 -72.32510376,5.50770092 -72.32569885,5.51520014 -72.3239975,5.53200102 -72.31529999,5.54930019 -72.30960083,5.56939983 -72.30789948,5.58910084 -72.30670166,5.61100101 -72.30560303,5.62370014 -72.29640198,5.63290119 -72.28430176,5.6415 -72.27159882,5.64840078 -72.25278473,5.66013718 -72.26180267,5.6692009 -72.27100372,5.67609978 -72.28659821,5.6940999 -72.29989624,5.70690012 -72.30680084,5.71850109 -72.31140137,5.73120022 -72.32180023,5.74860096 -72.33679962,5.76359987 -72.35929871,5.776999 -72.37480164,5.78520012 -72.40709686,5.79969978 -72.4088974,5.80090094 -72.41290283,5.80149984 -72.41870117,5.80620003 -72.4312973,5.8137002 -72.44229889,5.81610012 -72.45500183,5.81610012 -72.47519684,5.82890177 -72.47460175,5.83350086 -72.46829987,5.83810091 -72.4618988,5.84620094 -72.45559692,5.8560009 -72.4464035,5.86749887 -72.42970276,5.87200117 -72.42449951,5.87140083 -72.41989899,5.87549877 -72.41410065,5.88469982 -72.40950012,5.89160109 -72.40599823,5.91239786 -72.40139771,5.93139887 -72.39859772,5.94869995 -72.39569855,5.96260118 -72.39050293,5.98159981 -72.38710022,5.99090099 -72.38480377,6.00360012 -72.37729645,6.02259922 -72.37380219,6.03120089 -72.36810303,6.0428009 -72.36289978,6.04910088 -72.36000061,6.05429983 -72.35890198,6.06349993 -72.36460114,6.06820011 -72.3710022,6.06820011 -72.37729645,6.06879902 -72.38359833,6.07000113 -72.39060211,6.0758009 -72.39579773,6.08390093 -72.39749908,6.08910179 -72.40270233,6.09370089 -72.40609741,6.10240078 -72.40899658,6.11230087 -72.41889954,6.14060116 -72.42639923,6.15560007 -72.43389893,6.16950083 -72.43270111,6.18279886 -72.42810059,6.19319916 -72.42060089,6.20299911 -72.42120361,6.21630096 -72.41950226,6.22669983 -72.40329742,6.2104001 -72.39579773,6.18610001 -72.38140106,6.18029881 -72.36470032,6.18200016 -72.34449768,6.18010092 -72.33070374,6.17949915 -72.31220245,6.17309904 -72.30930328,6.16670179 -72.30760193,6.16150093 -72.30989838,6.14879894 -72.30870056,6.13609982 -72.30410004,6.12680101 -72.29260254,6.11470079 -72.28800201,6.10829878 -72.27929687,6.09610081 -72.26260376,6.09139919 -72.24240112,6.08209991 -72.22740173,6.07340097 -72.20549774,6.06059885 -72.1882019,6.05470085 -72.17269897,6.04949999 -72.15879822,6.04190111 -72.15070343,6.04010105 -72.14559937,6.04010105 -72.13809967,6.04300022 -72.13110352,6.04699898 -72.123703,6.05389786 -72.11160278,6.06650019 -72.10639954,6.07110119 -72.10119629,6.07399988 -72.0891037,6.08549881 -72.07530212,6.09180021 -72.04989624,6.09800005 -72.03949738,6.10090113 -72.02400208,6.10370016 -72.01239777,6.1065011 -72.00029755,6.11170006 -71.98999786,6.11569881 -71.98020172,6.12030077 -71.97090149,6.12770081 -71.96350098,6.13059998 -71.95249939,6.13400078 -71.93520355,6.13110018 -71.91500092,6.12979984 -71.85679626,6.13539982 -71.84760284,6.13700008 -71.83840179,6.14050102 -71.82969666,6.15030098 -71.81759644,6.16289997 -71.79799652,6.17320013 -71.79049683,6.17549896 -71.77149963,6.18180084 -71.74790192,6.18690014 -71.73120117,6.19199991 -71.70639801,6.1960001 -71.68509674,6.19990015 -71.66490173,6.20040083 -71.64589691,6.19399881 -71.62909698,6.18750095 -71.61470032,6.17479992 -71.60900116,6.17070007 -71.5951004,6.16489887 -71.58989716,6.16950083 -71.58529663,6.17409992 -71.58010101,6.1717 -71.56459808,6.16529989 -71.5605011,6.16880083 -71.55819702,6.17679882 -71.54840088,6.17799997 -71.53630066,6.16979885 -71.51959991,6.16800117 -71.51100159,6.17659998 -71.49649811,6.17600107 -71.4815979,6.17709923 -71.46600342,6.18509912 -71.45970154,6.19199991 -71.45970154,6.1967001 -71.4539032,6.20410013 -71.4464035,6.19720078 -71.44120026,6.19659996 -71.43080139,6.20060015 -71.42739868,6.20110083 -71.42160034,6.20110083 -71.41590118,6.20340109 -71.40090179,6.20680094 -71.3934021,6.20160007 -71.38990021,6.19920015 -71.38420105,6.19920015 -71.37439728,6.19920015 -71.36049652,6.20370102 -71.34780121,6.20889997 -71.33799744,6.21460009 -71.3184967,6.22900009 -71.31099701,6.23010111 -71.30059814,6.22950077 -71.29139709,6.22660017 -71.28559875,6.2322998 -71.28099823,6.23520088 -71.26999664,6.23280096 -71.25789642,6.23050022 -71.24990082,6.23039913 -71.23950195,6.24139786 -71.23829651,6.24599981 -71.23660278,6.24770021 -71.2233963,6.25050116 -71.20429993,6.24289989 -71.18360138,6.23710012 -71.16860199,6.23640013 -71.16280365,6.22950077 -71.14900208,6.22600079 -71.13510132,6.22710085 -71.12359619,6.22930098 -71.1006012,6.22919989 -71.08329773,6.22399902 -71.06310272,6.22209883 -71.04920197,6.22090006 -71.03019714,6.2203002 -71.01869965,6.21269894 -70.99510193,6.20160007 -70.97309875,6.19579983 -70.9598999,6.19460106 -70.9292984,6.19150114 -70.91609955,6.1862998 -70.90399933,6.18450022 -70.89649963,6.18450022 -70.88030243,6.18839884 -70.8687973,6.1994009 -70.85150146,6.19929981 -70.83589935,6.19920015 -70.82610321,6.20090008 -70.81349945,6.20489979 -70.79499817,6.20480013 -70.78179932,6.19610119 -70.77429962,6.19150114 -70.76329803,6.19079924 -70.75009918,6.191401 -70.73680115,6.19130087 -70.72350311,6.19130087 -70.71369934,6.19119978 -70.70680237,6.19060087 -70.68779755,6.18650103 -70.66880035,6.18810081 -70.64170074,6.19089985 -70.62270355,6.1960001 -70.61000061,6.19770002 -70.58809662,6.204 -70.57369995,6.20389986 -70.56040192,6.20559978 -70.54949951,6.20440102 -70.53849792,6.20200109 -70.52929687,6.21410084 -70.51599884,6.2060008 -70.51080322,6.2060008 -70.50330353,6.2111001 -70.498703,6.21630096 -70.49069977,6.22380114 -70.4803009,6.22489977 -70.46700287,6.22540092 -70.45780182,6.23060179 -70.44689941,6.24209976 -70.43710327,6.2420001 -70.41799927,6.2420001 -70.41290283,6.24480104 -70.39730072,6.24480104 -70.36789703,6.24579906 -70.354599,6.24570084 -70.33159637,6.24220085 -70.2940979,6.23910093 -70.27279663,6.24020004 -70.25779724,6.24359989 -70.23699951,6.24579906 -70.20880127,6.24630117 -70.20069885,6.24390078 -70.18569946,6.24330091 -70.18229675,6.24850178 -70.17250061,6.24790096 -70.16790009,6.24030018 -70.15859985,6.21950006 -70.13330078,6.20320177 -70.11190033,6.17889977 -70.08709717,6.16720104 -70.07499695,6.15210009 -70.0582962,6.13530016 -70.05709839,6.12030077 -70.05480194,6.10820103 -70.04560089,6.10580111 -70.0306015,6.10580111 -70.00810242,6.10679913 -70.0,6.11019993 -69.9815979,6.10550022 -69.95800018,6.09789896 -69.94059753,6.0788002 -69.9355011,6.07470179 -69.92910004,6.06719923 -69.92316437,6.05792284 -69.91760254,6.05620003 -69.92099762,6.04980087 -69.91870117,6.03480196 -69.91529846,6.02560091 -69.91120148,6.0163002 -69.90429687,6.01280117 -69.89559937,6.01050091 -69.88179779,6.00689983 -69.87200165,6.00689983 -69.8588028,6.00509977 -69.85179901,6.00449991 -69.84786987,6.00488091 -69.84950256,6.00099993 -69.85299683,5.99060011 -69.86100006,5.98260021 -69.87539673,5.96710014 -69.88240051,5.95489979 -69.89160156,5.92670012 -69.90650177,5.90880013 -69.92269897,5.89220095 -69.93070221,5.88870001 -69.9382019,5.87599993 -69.94229889,5.85760117 -69.95490265,5.83570099 -69.97109985,5.81780005 -69.97969818,5.79820013 -69.998703,5.7631011 -70.00330353,5.74120092 -70.01999664,5.72219992 -70.03730011,5.71010017 -70.04709625,5.69460011 -70.0522995,5.67780018 -70.04879761,5.66629887 -70.05049896,5.65409899 -70.08799744,5.64039898 -70.10009766,5.63530111 -70.11620331,5.63360119 -70.123703,5.62270021 -70.12599945,5.61810017 -70.12830353,5.59839916 -70.14150238,5.58809996 -70.1882019,5.56580114 -70.20549774,5.56529999 -70.22109985,5.55840111 -70.23950195,5.54460001 -70.25569916,5.54000092 -70.27639771,5.53550005 -70.29599762,5.53270102 -70.32430267,5.53279877 -70.34850311,5.53350115 -70.36289978,5.53360081 -70.38069916,5.53079987 -70.38829803,5.52912092 -70.39109802,5.52850103 -70.40149689,5.52330017 -70.41819763,5.51760006 -70.43260193,5.51020098 -70.44180298,5.50390005 -70.4464035,5.50159979 -70.48560333,5.47690105 -70.50119781,5.46830177 -70.50980377,5.45909882 -70.52310181,5.44820023 -70.53520203,5.43440008 -70.54789734,5.42340088 -70.56340027,5.41540098 -70.57720184,5.40679884 -70.59570312,5.39070177 -70.60140228,5.38439989 -70.63310242,5.36429977 -70.63890076,5.36139917 -70.65100098,5.35400105 -70.66940308,5.34130192 -70.6832962,5.33099985 -70.69249725,5.32180119 -70.69480133,5.30620098 -70.69709778,5.26809978 -70.70510101,5.25489998 -70.71379852,5.24039984 -70.72640228,5.22550106 -70.73970032,5.20819998 -70.75240326,5.19840002 -70.7696991,5.1887002 -70.78919983,5.17550087 -70.80370331,5.16629982 -70.82039642,5.1566 -70.83589935,5.14909983 -70.84799957,5.1329999 -70.85199738,5.12030077 -70.86759949,5.105299 -70.89530182,5.09330177 -70.91259766,5.08880091 -70.91490173,5.08880091 -70.92179871,5.08819914 -70.92870331,5.08599997 -70.9437027,5.0831008 -70.95410156,5.08259916 -70.96330261,5.07340097 -70.97190094,5.06249905 -70.97650146,5.05380011 -70.98059845,5.04460096 -70.98750305,5.03540087 -70.98919678,5.02150011 -70.99900055,5.00310087 -70.99900055,5.00019884 -71.00180054,4.98810196 -71.00700378,4.97190189 -71.0121994,4.96150017 -71.01679993,4.94660091 -71.0236969,4.93390179 -71.02890015,4.92810106 -71.03579712,4.91830111 -71.03929901,4.91600084 -71.06349945,4.89010096 -71.06690216,4.88610077 -71.07559967,4.87519979 -71.08249664,4.86650085 -71.08540344,4.86310005 -71.08540344,4.86020088 -71.08820343,4.85560179 -71.09980011,4.85040092 -71.11299896,4.84470081 -71.12689972,4.83729982 -71.14129639,4.82750177 -71.15619659,4.81720114 -71.1867981,4.80109882 -71.19490051,4.79649878 -71.22889709,4.7857008 -71.24900055,4.7777009 -71.26799774,4.76620007 -71.31759644,4.75080013 -71.33840179,4.74230099 -71.35679626,4.73480082 -71.37580109,4.72510099 -71.395401,4.71420002 -71.42939758,4.69760084 -71.45649719,4.68849993 -71.48590088,4.68109989 -71.5094986,4.67479992 -71.52739716,4.6651001 -71.55509949,4.65419912 -71.57350159,4.64850092 -71.58209991,4.63819981 -71.5861969,4.63180017 -71.59420013,4.62200022 -71.62020111,4.60830021 -71.62940216,4.60080099 -71.64089966,4.5939002 -71.67780304,4.58309889 -71.7071991,4.56470013 -71.72389984,4.55670023 -71.7417984,4.55220079 -71.75559998,4.54820108 -71.76190186,4.54650116 -71.76940155,4.54540014 -71.77809906,4.5442009 -71.78900146,4.54139996 -71.8132019,4.53280115 -71.82820129,4.52419996 -71.84259796,4.51620007 -71.85410309,4.50409985 -71.8628006,4.49320078 -71.87550354,4.48049879 -71.89219666,4.46330118 -71.91120148,4.44199991 -71.9312973,4.42879915 -71.94110107,4.41839981 -71.95089722,4.40110111 -71.95899963,4.38500118 -71.97280121,4.37580013 -71.9838028,4.36660004 -71.99700165,4.36319923 -72.00910187,4.35920191 -72.02819824,4.35990095 -72.04599762,4.34610081 -72.06159973,4.34560013 -72.0714035,4.3468008 -72.08180237,4.36130095 -72.08699799,4.37340117 -72.08869934,4.38029909 -72.09159851,4.38840008 -72.10140228,4.39890003 -72.12390137,4.40070009 -72.13829803,4.39789915 -72.16190338,4.39799881 -72.18440247,4.39690113 -72.20459747,4.394701 -72.22650146,4.38959789 -72.2621994,4.3902998 -72.27200317,4.38689995 -72.28299713,4.38230085 -72.29679871,4.37430096 -72.33190155,4.3593998 -72.35839844,4.34050083 -72.36650085,4.33179903 -72.38670349,4.31110001 -72.40110016,4.30189896 -72.41719818,4.29910088 -72.43219757,4.30380011 -72.43800354,4.3066988 -72.4484024,4.30970097 -72.46510315,4.3090992 -72.4713974,4.30170107 -72.48290253,4.28729916 -72.49330139,4.28729916 -72.50710297,4.29890013 -72.52159882,4.30760002 -72.53829956,4.3112011 -72.55329895,4.31530094 -72.56310272,4.31530094 -72.59529877,4.27209997 -72.60919952,4.27220011 -72.62180328,4.27570105 -72.63629913,4.28270006"
    },
    {
      "tipo_mapa": "poligono",
      "color": "#23a835",
      "puntos": "-73.66020203,1.610901 -73.686203,1.61269903 -73.71790314,1.6128 -73.73860168,1.61290002 -73.78990173,1.60619903 -73.82109833,1.59649897 -73.84349823,1.5862 -73.85910034,1.58170104 -73.89659882,1.57319999 -73.93060303,1.57040095 -73.95880127,1.57229996 -73.98529816,1.57579994 -74.00900269,1.58400095 -74.03199768,1.59280002 -74.04699707,1.60150003 -74.0562973,1.61250103 -74.05970001,1.62120104 -74.06259918,1.62409997 -74.07990265,1.63570094 -74.09320068,1.64730096 -74.11849976,1.64919996 -74.14050293,1.65850103 -74.15779877,1.68340099 -74.16989899,1.70249999 -74.18830109,1.72860003 -74.20220184,1.74370003 -74.22350311,1.76400006 -74.24659729,1.77450001 -74.27480316,1.78499997 -74.30020142,1.78680003 -74.37280273,1.79520094 -74.40450287,1.79709995 -74.43630219,1.79949999 -74.47200012,1.80660105 -74.48760223,1.81540096 -74.50370026,1.82810104 -74.51180267,1.83739901 -74.52220154,1.84899998 -74.54060364,1.86700106 -74.54989624,1.88090098 -74.56140137,1.90170097 -74.5746994,1.91739905 -74.58509827,1.93069994 -74.59020233,1.94400096 -74.59660339,1.96710098 -74.60639954,1.97930098 -74.6167984,2.00130105 -74.6312027,2.03779888 -74.63179779,2.06090093 -74.63179779,2.07819891 -74.6289978,2.10759997 -74.6289978,2.13019991 -74.6289978,2.14520097 -74.63130188,2.17000103 -74.63480377,2.1868 -74.64230347,2.20709991 -74.64980316,2.22040105 -74.65380096,2.23140001 -74.65789795,2.239501 -74.66079712,2.24810004 -74.66190338,2.2499001 -74.6631012,2.27130103 -74.66649628,2.30250001 -74.67169952,2.31920004 -74.67289734,2.33310008 -74.67459869,2.35330009 -74.67749786,2.37759995 -74.67870331,2.40420008 -74.67810059,2.42269993 -74.67639923,2.44059992 -74.68099976,2.46020103 -74.68910217,2.47930002 -74.69259644,2.49780011 -74.69550323,2.51860094 -74.6914978,2.53649902 -74.68340302,2.55500102 -74.67299652,2.57570004 -74.66149902,2.59300089 -74.6529007,2.60159993 -74.64080048,2.61599994 -74.62470245,2.63500094 -74.61599731,2.64820004 -74.60510254,2.66779995 -74.60449982,2.69380093 -74.60449982,2.71519899 -74.60449982,2.74760008 -74.604599,2.76660109 -74.60919952,2.77880096 -74.62879944,2.7926991 -74.646698,2.8014009 -74.66739655,2.81939912 -74.69339752,2.8328011 -74.72329712,2.84389997 -74.7457962,2.86019993 -74.76490021,2.87299991 -74.8144989,2.89750099 -74.82769775,2.89869905 -74.84500122,2.90619993 -74.85890198,2.91149902 -74.87380219,2.91680002 -74.88710022,2.92430091 -74.89630127,2.93190002 -74.91590118,2.94060111 -74.92060089,2.9440999 -74.91020203,2.96950102 -74.9016037,2.98620009 -74.87850189,3.0052011 -74.86810303,3.02010012 -74.86119843,3.027601 -74.85369873,3.03570104 -74.84909821,3.0460999 -74.84570312,3.05640006 -74.84339905,3.05819988 -74.8266983,3.06789994 -74.81739807,3.07189989 -74.8065033,3.08170009 -74.79319763,3.08570004 -74.78170013,3.09139991 -74.7661972,3.09829903 -74.75229645,3.10339999 -74.72930145,3.11540008 -74.72409821,3.13789892 -74.71890259,3.15060091 -74.71549988,3.17199993 -74.71029663,3.18700099 -74.69470215,3.20250106 -74.6815033,3.21569991 -74.67569733,3.2198 -74.67050171,3.22609997 -74.6595993,3.23990011 -74.64689636,3.25429893 -74.63600159,3.27390003 -74.63140106,3.2901001 -74.62329865,3.31369996 -74.62280273,3.3316009 -74.62159729,3.34720111 -74.61990356,3.355901 -74.61930084,3.37089992 -74.61990356,3.40149999 -74.62220001,3.43040109 -74.62220001,3.44890094 -74.61650085,3.47710109 -74.60900116,3.4914999 -74.60209656,3.49900103 -74.59629822,3.50880098 -74.58249664,3.52260089 -74.57099915,3.53930092 -74.55999756,3.56010008 -74.55259705,3.57740092 -74.54509735,3.59240007 -74.53700256,3.6085 -74.52670288,3.626899 -74.52089691,3.63669991 -74.5196991,3.65000105 -74.51920319,3.65750098 -74.51689911,3.66560102 -74.51000214,3.66210103 -74.49780273,3.65459991 -74.48110199,3.65560007 -74.44999695,3.66470098 -74.43789673,3.67569995 -74.43160248,3.69070101 -74.42579651,3.71199989 -74.41719818,3.72700095 -74.40570068,3.73849893 -74.39409637,3.74600005 -74.38899994,3.75459909 -74.38379669,3.76379991 -74.3647995,3.77879906 -74.33999634,3.80520105 -74.32959747,3.82019997 -74.32499695,3.83809996 -74.32559967,3.85249996 -74.32730103,3.86809993 -74.31749725,3.88019991 -74.30259705,3.89059997 -74.28639984,3.90610003 -74.27610016,3.91700101 -74.25990295,3.93889904 -74.251297,3.96140099 -74.24150085,3.97929907 -74.23860168,3.98560095 -74.22940063,3.9907999 -74.21959686,3.99940109 -74.21559906,4.0034008 -74.1977005,4.00619984 -74.17520142,4.00610018 -74.14530182,4.01470089 -74.1140976,4.02089977 -74.09049988,4.03700018 -74.08529663,4.03980112 -74.07089996,4.05360079 -74.05999756,4.06630087 -74.05190277,4.079 -74.03919983,4.08869982 -74.00810242,4.09550095 -73.99140167,4.09489918 -73.9776001,4.09600019 -73.97239685,4.09540081 -73.95510101,4.09650183 -73.92910004,4.10040092 -73.91239929,4.10960007 -73.88880157,4.12560177 -73.86340332,4.13710022 -73.8368988,4.15030098 -73.80989838,4.1668992 -73.77590179,4.18810177 -73.77120209,4.19329882 -73.76429749,4.20020008 -73.76550293,4.21350098 -73.76779938,4.22099876 -73.78050232,4.2314992 -73.79149628,4.24889994 -73.79380035,4.26450109 -73.7960968,4.27260113 -73.80069733,4.28760004 -73.79959869,4.30550098 -73.80239868,4.31589985 -73.80480194,4.32519913 -73.8065033,4.34190083 -73.8105011,4.35290003 -73.82029724,4.36050081 -73.82900238,4.36569881 -73.83529663,4.37610102 -73.83480072,4.38129997 -73.8302002,4.39400196 -73.82610321,4.4073 -73.82330322,4.41590023 -73.81169891,4.4296999 -73.79620361,4.44759989 -73.77539825,4.46480083 -73.75589752,4.48670101 -73.72360229,4.50500011 -73.70970154,4.50320005 -73.70110321,4.49280024 -73.69709778,4.48640013 -73.69360352,4.47780085 -73.69190216,4.47259998 -73.68319702,4.46730089 -73.66819763,4.47530079 -73.66649628,4.47009993 -73.65670013,4.46490097 -73.64569855,4.46140003 -73.6359024,4.45610094 -73.62380219,4.45959997 -73.62090302,4.4567008 -73.61399841,4.45200109 -73.61229706,4.45079994 -73.60359955,4.44560099 -73.60250092,4.43979883 -73.60250092,4.43460178 -73.60420227,4.42659998 -73.61000061,4.41330099 -73.61229706,4.40980101 -73.61377716,4.40725899 -73.61049652,4.39650011 -73.60939789,4.38609982 -73.60820007,4.37750101 -73.60240173,4.36819983 -73.59549713,4.36009979 -73.58860016,4.34789896 -73.58229828,4.33690023 -73.57820129,4.33109999 -73.57420349,4.31669998 -73.57129669,4.29990101 -73.57420349,4.28489923 -73.56089783,4.26980019 -73.55169678,4.26399994 -73.54129791,4.26459885 -73.52110291,4.25930023 -73.47329712,4.26249981 -73.45480347,4.26529884 -73.44039917,4.27449989 -73.41619873,4.28480101 -73.38800049,4.27839899 -73.36260223,4.27069998 -73.32910156,4.26139879 -73.29049683,4.25540113 -73.25189972,4.24889994 -73.20580292,4.22330093 -73.1815033,4.20470095 -73.15910339,4.19770002 -73.14579773,4.19070005 -73.13829803,4.22130013 -73.10959625,4.43720007 -73.07230377,4.666399 -73.04570007,4.63450098 -73.03710175,4.61880016 -73.0243988,4.5968008 -73.00250244,4.56269884 -72.98059845,4.53540087 -72.95230103,4.49949789 -72.93319702,4.47520018 -72.91770172,4.45889997 -72.89520264,4.43860006 -72.87729645,4.41830015 -72.87149811,4.40959978 -72.87149811,4.40619993 -72.86979675,4.39750004 -72.8588028,4.39860106 -72.84899902,4.39569998 -72.84899902,4.38410091 -72.84960175,4.3730998 -72.84670258,4.37080002 -72.82649994,4.37129879 -72.81330109,4.36550093 -72.82129669,4.35679913 -72.82360077,4.34760094 -72.8167038,4.34180021 -72.80809784,4.33080101 -72.813797,4.32330084 -72.80860138,4.31689787 -72.80169678,4.31399918 -72.79190063,4.31280088 -72.78099823,4.30530024 -72.77290344,4.29369879 -72.771698,4.28790092 -72.76999664,4.27980089 -72.7677002,4.26590109 -72.75669861,4.26179981 -72.74690247,4.25310087 -72.73139954,4.24669886 -72.72499847,4.2473011 -72.72100067,4.26050091 -72.71469879,4.26629877 -72.71060181,4.27029896 -72.70079803,4.27139997 -72.68579865,4.27370024 -72.67140198,4.27359915 -72.65529633,4.27530003 -72.64550018,4.27869987 -72.63629913,4.28270006 -72.62180328,4.27570105 -72.60919952,4.27220011 -72.59529877,4.27209997 -72.56310272,4.31530094 -72.55329895,4.31530094 -72.53829956,4.3112011 -72.52159882,4.30760002 -72.50710297,4.29890013 -72.49330139,4.28729916 -72.48290253,4.28729916 -72.4713974,4.30170107 -72.46510315,4.3090992 -72.4484024,4.30970097 -72.43800354,4.3066988 -72.43219757,4.30380011 -72.41719818,4.29910088 -72.40110016,4.30189896 -72.38670349,4.31110001 -72.36650085,4.33179903 -72.35839844,4.34050083 -72.33190155,4.3593998 -72.29679871,4.37430096 -72.28299713,4.38230085 -72.27200317,4.38689995 -72.2621994,4.3902998 -72.22650146,4.38959789 -72.20459747,4.394701 -72.18440247,4.39690113 -72.16190338,4.39799881 -72.13829803,4.39789915 -72.12390137,4.40070009 -72.10140228,4.39890003 -72.09159851,4.38840008 -72.08869934,4.38029909 -72.08699799,4.37340117 -72.08180237,4.36130095 -72.0714035,4.3468008 -72.06159973,4.34560013 -72.04599762,4.34610081 -72.02819824,4.35990095 -72.00910187,4.35920191 -71.99700165,4.36319923 -71.9838028,4.36660004 -71.97280121,4.37580013 -71.95899963,4.38500118 -71.95089722,4.40110111 -71.94110107,4.41839981 -71.9312973,4.42879915 -71.91120148,4.44199991 -71.89219666,4.46330118 -71.87550354,4.48049879 -71.8628006,4.49320078 -71.85410309,4.50409985 -71.84259796,4.51620007 -71.82820129,4.52419996 -71.8132019,4.53280115 -71.78900146,4.54139996 -71.77809906,4.5442009 -71.76940155,4.54540014 -71.76190186,4.54650116 -71.75559998,4.54820108 -71.7417984,4.55220079 -71.72389984,4.55670023 -71.7071991,4.56470013 -71.67780304,4.58309889 -71.64089966,4.5939002 -71.62940216,4.60080099 -71.62020111,4.60830021 -71.59420013,4.62200022 -71.5861969,4.63180017 -71.58209991,4.63819981 -71.57350159,4.64850092 -71.55509949,4.65419912 -71.52739716,4.6651001 -71.5094986,4.67479992 -71.48590088,4.68109989 -71.45649719,4.68849993 -71.42939758,4.69760084 -71.395401,4.71420002 -71.37580109,4.72510099 -71.35679626,4.73480082 -71.33840179,4.74230099 -71.31759644,4.75080013 -71.26799774,4.76620007 -71.24900055,4.7777009 -71.22889709,4.7857008 -71.19490051,4.79649878 -71.1867981,4.80109882 -71.15619659,4.81720114 -71.14129639,4.82750177 -71.12689972,4.83729982 -71.11299896,4.84470081 -71.09980011,4.85040092 -71.08820343,4.85560179 -71.08540344,4.86020088 -71.07489777,4.6724 -71.07990265,4.44490194 -71.08609772,4.18730021 -71.09780121,3.3434 -71.09519958,2.84549999 -71.10320282,2.84730005 -71.10839844,2.84270096 -71.12280273,2.8375001 -71.13150024,2.84559989 -71.15170288,2.8527 -71.15630341,2.84809995 -71.15450287,2.84340096 -71.15399933,2.83999991 -71.16660309,2.83599997 -71.17410278,2.83770108 -71.19139862,2.8447001 -71.20410156,2.8500011 -71.21679687,2.84540009 -71.22660065,2.83969903 -71.23519897,2.83450103 -71.25939941,2.83349991 -71.26460266,2.8375001 -71.28939819,2.83820009 -71.30439758,2.84870005 -71.31189728,2.86950111 -71.3239975,2.877599 -71.3309021,2.87590098 -71.33730316,2.86669993 -71.34880066,2.84890008 -71.36440277,2.8368001 -71.36840057,2.83330011 -71.36840057,2.83969903 -71.37239838,2.84660101 -71.38169861,2.85019898 -71.39089966,2.84039903 -71.39089966,2.83109999 -71.39369965,2.82540011 -71.39550018,2.81610107 -71.41329956,2.81559992 -71.41850281,2.81680107 -71.43060303,2.82209992 -71.45259857,2.83540106 -71.46520233,2.84360099 -71.47619629,2.84940004 -71.48660278,2.83730006 -71.48889923,2.83210111 -71.49060059,2.82810092 -71.49639893,2.826401 -71.49919891,2.82810092 -71.50150299,2.82870007 -71.51129913,2.83109999 -71.5177002,2.832201 -71.52809906,2.83520007 -71.53839874,2.8323009 -71.55169678,2.83470106 -71.5632019,2.82610011 -71.57939911,2.8256011 -71.59089661,2.82330108 -71.59259796,2.81640005 -71.59259796,2.81410003 -71.59670258,2.8112011 -71.62660217,2.81129909 -71.6588974,2.81200099 -71.66809845,2.80800104 -71.67790222,2.80749989 -71.67680359,2.81960011 -71.67620087,2.82650089 -71.6894989,2.82949996 -71.7009964,2.82550001 -71.7118988,2.81860209 -71.73040009,2.82390094 -71.74770355,2.83959889 -71.7661972,2.85179901 -71.78230286,2.85819888 -71.78690338,2.8460989 -71.79039764,2.83509994 -71.78859711,2.826401 -71.78690338,2.82010102 -71.78690338,2.81369901 -71.79149628,2.81200099 -71.7990036,2.81610107 -71.80249786,2.82130003 -71.81459808,2.82250094 -71.81800079,2.81789994 -71.8219986,2.81210089 -71.82319641,2.81040096 -71.83470154,2.80640101 -71.85430145,2.801301 -71.87560272,2.79910111 -71.90450287,2.79460001 -71.94020081,2.79069996 -71.96040344,2.7895999 -71.97309875,2.78389907 -71.98629761,2.77699995 -71.99900055,2.77070093 -72.00589752,2.76959991 -72.01689911,2.7789011 -72.02670288,2.78700089 -72.03240204,2.79220009 -72.04799652,2.7940011 -72.06469727,2.79530001 -72.08370209,2.79710007 -72.10849762,2.80870104 -72.12069702,2.82150102 -72.12989807,2.83770108 -72.14949799,2.85630107 -72.16739655,2.84540009 -72.18229675,2.83330011 -72.20020294,2.82820106 -72.21459961,2.82880092 -72.22100067,2.82880092 -72.2220993,2.81089997 -72.2181015,2.79879999 -72.21520233,2.7854991 -72.21399689,2.77509999 -72.20770264,2.75999999 -72.20020294,2.75310111 -72.19789886,2.7421 -72.1984024,2.73520088 -72.20529938,2.72880101 -72.21279907,2.728899 -72.21800232,2.72830009 -72.23709869,2.74230099 -72.2594986,2.7626009 -72.27570343,2.77710104 -72.28890228,2.77140093 -72.29070282,2.76670098 -72.29119873,2.75110006 -72.3010025,2.74890089 -72.31659698,2.75180006 -72.32929993,2.75360107 -72.34490204,2.75310111 -72.36440277,2.74509907 -72.3812027,2.73190093 -72.39790344,2.71869993 -72.42030334,2.7032001 -72.43360138,2.68939996 -72.45429993,2.67959905 -72.46929932,2.67740011 -72.49349976,2.68330097 -72.51779938,2.68340111 -72.53040314,2.68170094 -72.53910065,2.66500092 -72.54309845,2.65049911 -72.56099701,2.63619995 -72.57710266,2.63619995 -72.60299683,2.63630009 -72.61920166,2.63580108 -72.61340332,2.62020111 -72.6013031,2.60919905 -72.58979797,2.60159993 -72.58979797,2.59120107 -72.59670258,2.58380008 -72.60420227,2.58320093 -72.6167984,2.58330107 -72.6289978,2.59080005 -72.65029907,2.59780097 -72.66069794,2.59669995 -72.66529846,2.58520007 -72.66870117,2.57600093 -72.67220306,2.56040096 -72.68309784,2.55180097 -72.68830109,2.56329989 -72.69409943,2.58419895 -72.69760132,2.59570003 -72.70559692,2.60270095 -72.72350311,2.60279894 -72.73210144,2.59990001 -72.73390198,2.59069896 -72.73619843,2.57570004 -72.74189758,2.56070089 -72.7539978,2.55029893 -72.77940369,2.56319904 -72.78749847,2.56200004 -72.80020142,2.57480001 -72.81279755,2.58349991 -72.84220123,2.58189988 -72.85379791,2.57559991 -72.85949707,2.57220006 -72.87509918,2.56070089 -72.90619659,2.54640007 -72.917099,2.53769994 -72.93389893,2.52910089 -72.94539642,2.52279902 -72.94940186,2.5119009 -72.94940186,2.50029993 -72.95459747,2.49230003 -72.96730042,2.49000001 -72.97360229,2.48830009 -72.96900177,2.47609997 -72.94589996,2.465101 -72.93789673,2.45519996 -72.93779755,2.44420099 -72.94709778,2.44309998 -72.95400238,2.4454999 -72.96440125,2.44670105 -72.9776001,2.45249891 -72.98509979,2.44910097 -72.98049927,2.43060088 -72.97650146,2.41670108 -72.9701004,2.4039011 -72.96489716,2.38890004 -72.9776001,2.39010096 -72.98339844,2.39820099 -72.98629761,2.41330099 -73.00009918,2.41969991 -73.00640106,2.42429996 -73.01280212,2.41680098 -73.02490234,2.4111011 -73.03639984,2.40309906 -73.04560089,2.40140104 -73.05200195,2.4020009 -73.05719757,2.40719891 -73.06580353,2.41300011 -73.07620239,2.41129899 -73.08139801,2.4073 -73.08650208,2.40100002 -73.09400177,2.39180112 -73.10379791,2.38720012 -73.1072998,2.38319993 -73.11360168,2.37220097 -73.12110138,2.36470008 -73.12799835,2.36529994 -73.12966156,2.38053608 -73.14360046,2.38790011 -73.15110016,2.386199 -73.15920258,2.38510108 -73.1638031,2.38170004 -73.15920258,2.3730011 -73.15399933,2.36540008 -73.14299774,2.35789895 -73.15280151,2.35500002 -73.15509796,2.35450101 -73.16320038,2.35280108 -73.16840363,2.35050106 -73.17759705,2.34940004 -73.17819977,2.35570002 -73.17819977,2.3598001 -73.17649841,2.37019992 -73.18219757,2.37880111 -73.20069885,2.3737011 -73.21330261,2.36970091 -73.22370148,2.36859989 -73.22599792,2.375 -73.23069763,2.38479996 -73.24330139,2.38140011 -73.24790192,2.37390089 -73.25489807,2.36640096 -73.26580048,2.3618989 -73.28079987,2.35789895 -73.27960205,2.34859991 -73.26059723,2.35030103 -73.25370026,2.34910011 -73.25430298,2.34220099 -73.26290131,2.33299994 -73.27559662,2.34169888 -73.29350281,2.33020091 -73.30560303,2.32450104 -73.3125,2.32340002 -73.32230377,2.3217001 -73.33380127,2.322299 -73.33899689,2.32809997 -73.34649658,2.3275001 -73.35279846,2.32060099 -73.35970306,2.31259894 -73.3690033,2.31030011 -73.36779785,2.31839991 -73.36260223,2.33510089 -73.37419891,2.34380102 -73.38400269,2.34209991 -73.39150238,2.33520103 -73.39489746,2.3289001 -73.39489746,2.32430005 -73.39489746,2.3179009 -73.38800049,2.31150103 -73.39550018,2.30580091 -73.40579987,2.30640006 -73.40409851,2.31850004 -73.40180206,2.32549906 -73.41220093,2.33069992 -73.42199707,2.33020091 -73.4265976,2.32850099 -73.43759918,2.32620096 -73.44740295,2.32159996 -73.4496994,2.33030105 -73.4496994,2.3400991 -73.45030212,2.35219908 -73.45659637,2.36560106 -73.4641037,2.36670089 -73.47679901,2.36160111 -73.47499847,2.3546989 -73.4681015,2.34599996 -73.46640015,2.33900094 -73.46469879,2.33209991 -73.46579742,2.31999993 -73.47450256,2.31829906 -73.47850037,2.31769991 -73.48370361,2.32870102 -73.48660278,2.33449888 -73.49349976,2.3414011 -73.51599884,2.33400011 -73.52629852,2.32430005 -73.53330231,2.3230989 -73.53669739,2.33010101 -73.53610229,2.33590102 -73.53610229,2.34220099 -73.54879761,2.36540008 -73.5562973,2.3567009 -73.56269836,2.34400105 -73.57710266,2.33139992 -73.58799744,2.34179997 -73.59670258,2.35629892 -73.6053009,2.36560106 -73.61630249,2.3599 -73.61920166,2.35409999 -73.62200165,2.34310102 -73.63179779,2.33740091 -73.63760376,2.33740091 -73.64450073,2.33459997 -73.64800262,2.33289909 -73.64800262,2.32300091 -73.63410187,2.31839991 -73.63300323,2.31660104 -73.64659882,1.96370006 -73.66020203,1.610901"
    },
    {
      "tipo_mapa": "oleoducto",
      "puntos": [
        {
          "id": "82",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.938025",
            "lng": "-71.81200833"
          }
        },
        {
          "id": "82",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.936472222",
            "lng": "-71.80911389"
          }
        },
        {
          "id": "83",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.937086111",
            "lng": "-71.80534722"
          }
        },
        {
          "id": "84",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.934361111",
            "lng": "-71.79532222"
          }
        },
        {
          "id": "85",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.934361111",
            "lng": "-71.79532222"
          }
        },
        {
          "id": "86",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.931611111",
            "lng": "-71.78970833"
          }
        },
        {
          "id": "87",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.930638889",
            "lng": "-71.78863889"
          }
        },
        {
          "id": "88",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.924797222",
            "lng": "-71.78450278"
          }
        },
        {
          "id": "89",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.915927778",
            "lng": "-71.78594444"
          }
        },
        {
          "id": "90",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.906883333",
            "lng": "-71.78650833"
          }
        },
        {
          "id": "91",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.897725",
            "lng": "-71.78739444"
          }
        },
        {
          "id": "92",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.889636111",
            "lng": "-71.78771389"
          }
        },
        {
          "id": "93",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.880697222",
            "lng": "-71.785425"
          }
        },
        {
          "id": "94",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.871763889",
            "lng": "-71.78387778"
          }
        },
        {
          "id": "95",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.863730556",
            "lng": "-71.78153056"
          }
        },
        {
          "id": "96",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.854761111",
            "lng": "-71.78131944"
          }
        },
        {
          "id": "97",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.854305556",
            "lng": "-71.78119444"
          }
        },
        {
          "id": "98",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.849177778",
            "lng": "-71.77485556"
          }
        },
        {
          "id": "99",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.842711111",
            "lng": "-71.76915833"
          }
        },
        {
          "id": "100",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.834463889",
            "lng": "-71.76534167"
          }
        },
        {
          "id": "101",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.825625",
            "lng": "-71.76125278"
          }
        },
        {
          "id": "102",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.817594444",
            "lng": "-71.75446111"
          }
        },
        {
          "id": "103",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.813286111",
            "lng": "-71.75293333"
          }
        },
        {
          "id": "104",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.803333333",
            "lng": "-71.7504"
          }
        },
        {
          "id": "105",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.794883333",
            "lng": "-71.74535833"
          }
        },
        {
          "id": "106",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.788327778",
            "lng": "-71.74046944"
          }
        },
        {
          "id": "107",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.780366667",
            "lng": "-71.73383333"
          }
        },
        {
          "id": "108",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.775041667",
            "lng": "-71.73"
          }
        },
        {
          "id": "109",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.765711111",
            "lng": "-71.72428611"
          }
        },
        {
          "id": "110",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.760669444",
            "lng": "-71.700175"
          }
        },
        {
          "id": "111",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.753472222",
            "lng": "-71.71181667"
          }
        },
        {
          "id": "112",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.746002778",
            "lng": "-71.706925"
          }
        },
        {
          "id": "113",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.737830556",
            "lng": "-71.70295"
          }
        },
        {
          "id": "114",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.729975",
            "lng": "-71.69865833"
          }
        },
        {
          "id": "115",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.722630556",
            "lng": "-71.69357222"
          }
        },
        {
          "id": "116",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.718397222",
            "lng": "-71.68569444"
          }
        },
        {
          "id": "117",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.720330556",
            "lng": "-71.68878611"
          }
        },
        {
          "id": "118",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.711925",
            "lng": "-71.68008611"
          }
        },
        {
          "id": "119",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.703833333",
            "lng": "-71.6832"
          }
        },
        {
          "id": "120",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.69495",
            "lng": "-71.68353333"
          }
        },
        {
          "id": "121",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.686413889",
            "lng": "-71.68425833"
          }
        },
        {
          "id": "122",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.679827778",
            "lng": "-71.6903"
          }
        },
        {
          "id": "123",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.685611111",
            "lng": "-71.68530556"
          }
        },
        {
          "id": "124",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.672875",
            "lng": "-71.69604722"
          }
        },
        {
          "id": "125",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.670022222",
            "lng": "-71.69838611"
          }
        },
        {
          "id": "126",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.669291667",
            "lng": "-71.69898333"
          }
        },
        {
          "id": "127",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.665741667",
            "lng": "-71.70146944"
          }
        },
        {
          "id": "128",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.660786111",
            "lng": "-71.70840278"
          }
        },
        {
          "id": "129",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.654569444",
            "lng": "-71.70531667"
          }
        },
        {
          "id": "130",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.646213889",
            "lng": "-71.70211667"
          }
        },
        {
          "id": "131",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.644833333",
            "lng": "-71.70180556"
          }
        },
        {
          "id": "132",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.637844444",
            "lng": "-71.6992"
          }
        },
        {
          "id": "133",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.628980556",
            "lng": "-71.69849722"
          }
        },
        {
          "id": "134",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.620405556",
            "lng": "-71.70046667"
          }
        },
        {
          "id": "135",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.611908333",
            "lng": "-71.70221944"
          }
        },
        {
          "id": "136",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.602858333",
            "lng": "-71.70216944"
          }
        },
        {
          "id": "137",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.593988889",
            "lng": "-71.70108056"
          }
        },
        {
          "id": "138",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.585872222",
            "lng": "-71.69791111"
          }
        },
        {
          "id": "139",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.580080556",
            "lng": "-71.69101667"
          }
        },
        {
          "id": "140",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.573669444",
            "lng": "-71.68503889"
          }
        },
        {
          "id": "141",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.565430556",
            "lng": "-71.68123056"
          }
        },
        {
          "id": "142",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.556608333",
            "lng": "-71.67924444"
          }
        },
        {
          "id": "143",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.559",
            "lng": "-71.67972222"
          }
        },
        {
          "id": "144",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.549452778",
            "lng": "-71.67444722"
          }
        },
        {
          "id": "145",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.5417",
            "lng": "-71.67009444"
          }
        },
        {
          "id": "146",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.538194444",
            "lng": "-71.66977778"
          }
        },
        {
          "id": "147",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.533586111",
            "lng": "-71.67239167"
          }
        },
        {
          "id": "148",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.527108333",
            "lng": "-71.67786944"
          }
        },
        {
          "id": "149",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.517916667",
            "lng": "-71.6799"
          }
        },
        {
          "id": "150",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.510016667",
            "lng": "-71.67561111"
          }
        },
        {
          "id": "151",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.506055556",
            "lng": "-71.67322222"
          }
        },
        {
          "id": "152",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.502533333",
            "lng": "-71.67091389"
          }
        },
        {
          "id": "153",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.499394444",
            "lng": "-71.6691"
          }
        },
        {
          "id": "154",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.499394444",
            "lng": "-71.6691"
          }
        },
        {
          "id": "155",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.501088889",
            "lng": "-71.67005556"
          }
        },
        {
          "id": "156",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.494738889",
            "lng": "-71.66645556"
          }
        },
        {
          "id": "157",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.486261111",
            "lng": "-71.66361667"
          }
        },
        {
          "id": "158",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.477358333",
            "lng": "-71.66180556"
          }
        },
        {
          "id": "159",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.468336111",
            "lng": "-71.65774722"
          }
        },
        {
          "id": "160",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.461583333",
            "lng": "-71.65383333"
          }
        },
        {
          "id": "161",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.461383333",
            "lng": "-71.65372222"
          }
        },
        {
          "id": "162",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.453775",
            "lng": "-71.64883333"
          }
        },
        {
          "id": "163",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.446138889",
            "lng": "-71.64405556"
          }
        },
        {
          "id": "164",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.437705556",
            "lng": "-71.64646389"
          }
        },
        {
          "id": "165",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.430413889",
            "lng": "-71.6516"
          }
        },
        {
          "id": "166",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.422591667",
            "lng": "-71.656325"
          }
        },
        {
          "id": "167",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.415072222",
            "lng": "-71.6611"
          }
        },
        {
          "id": "168",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.407636111",
            "lng": "-71.66607778"
          }
        },
        {
          "id": "169",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.408694444",
            "lng": "-71.66533333"
          }
        },
        {
          "id": "170",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.400486111",
            "lng": "-71.67166389"
          }
        },
        {
          "id": "171",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.393419444",
            "lng": "-71.67728611"
          }
        },
        {
          "id": "172",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.386063889",
            "lng": "-71.68327778"
          }
        },
        {
          "id": "173",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.3865",
            "lng": "-71.68275556"
          }
        },
        {
          "id": "174",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.380336111",
            "lng": "-71.68686111"
          }
        },
        {
          "id": "175",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.369844444",
            "lng": "-71.68869722"
          }
        },
        {
          "id": "176",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.360941667",
            "lng": "-71.69025"
          }
        },
        {
          "id": "177",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.352047222",
            "lng": "-71.69196667"
          }
        },
        {
          "id": "178",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.343163889",
            "lng": "-71.69370556"
          }
        },
        {
          "id": "179",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.334372222",
            "lng": "-71.69543333"
          }
        },
        {
          "id": "180",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.326269444",
            "lng": "-71.69225833"
          }
        },
        {
          "id": "181",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.319683333",
            "lng": "-71.68621111"
          }
        },
        {
          "id": "182",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.312980556",
            "lng": "-71.68010556"
          }
        },
        {
          "id": "183",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.306488889",
            "lng": "-71.67398056"
          }
        },
        {
          "id": "184",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.299377778",
            "lng": "-71.66834167"
          }
        },
        {
          "id": "185",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.29775",
            "lng": "-71.66688889"
          }
        },
        {
          "id": "186",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.292716667",
            "lng": "-71.66230556"
          }
        },
        {
          "id": "187",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.286116667",
            "lng": "-71.65622222"
          }
        },
        {
          "id": "188",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.279413889",
            "lng": "-71.65009722"
          }
        },
        {
          "id": "189",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.273438889",
            "lng": "-71.64313056"
          }
        },
        {
          "id": "190",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.267738889",
            "lng": "-71.63638889"
          }
        },
        {
          "id": "191",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.258880556",
            "lng": "-71.63486667"
          }
        },
        {
          "id": "192",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.250930556",
            "lng": "-71.63148889"
          }
        },
        {
          "id": "193",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.244994444",
            "lng": "-71.62469722"
          }
        },
        {
          "id": "194",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.237841667",
            "lng": "-71.62033333"
          }
        },
        {
          "id": "195",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.239777778",
            "lng": "-71.62027778"
          }
        },
        {
          "id": "196",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.228819444",
            "lng": "-71.61985"
          }
        },
        {
          "id": "197",
          "suceso": " OLEODUCTO",
          "puntos": {
            "lat": "6.226102778",
            "lng": "-71.61938889"
          }
        }
      ]
    },
    {
      "tipo_mapa": "puntos_oleducto",
      "puntos": [
        // {
        //   "id": "82",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.42054",
        //     "lng": "-72.26808"
        //   }
        // },
        // {
        //   "id": "110",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.42385",
        //     "lng": "-72.20139"
        //   }
        // },
        // {
        //   "id": "111",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.43888",
        //     "lng": "-72.18872"
        //   }
        // },
        // {
        //   "id": "112",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.58882",
        //     "lng": "-72.00181"
        //   }
        // },
        // {
        //   "id": "119",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.60551",
        //     "lng": "-71.98486"
        //   }
        // },
        // {
        //   "id": "120",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.63307",
        //     "lng": "-71.94497"
        //   }
        // },
        // {
        //   "id": "121",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.70788",
        //     "lng": "-71.90608"
        //   }
        // },
        // {
        //   "id": "122",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.73654",
        //     "lng": "-71.89672"
        //   }
        // },
        // {
        //   "id": "130",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.78571",
        //     "lng": "-71.88506"
        //   }
        // },
        // {
        //   "id": "136",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.83501",
        //     "lng": "-71.86203"
        //   }
        // },
        // {
        //   "id": "137",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.84938",
        //     "lng": "-71.85972"
        //   }
        // },
        // {
        //   "id": "138",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.88404",
        //     "lng": "-71.85681"
        //   }
        // },
        // {
        //   "id": "139",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.90338",
        //     "lng": "-71.86936"
        //   }
        // },
        // {
        //   "id": "140",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.91785",
        //     "lng": "-71.87456"
        //   }
        // },
        // {
        //   "id": "141",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.94785",
        //     "lng": "-71.84872"
        //   }
        // },
        // {
        //   "id": "142",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.94785",
        //     "lng": "-71.84872"
        //   }
        // },
        // {
        //   "id": "143",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.97046",
        //     "lng": "-71.81628"
        //   }
        // },
        // {
        //   "id": "144",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.97046",
        //     "lng": "-71.81628"
        //   }
        // },
        // {
        //   "id": "145",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "5.98060",
        //     "lng": "-71.80428"
        //   }
        // }

        
        // ,
        // {
        //   "id": "146",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "6.01451",
        //     "lng": "-71.79622"
        //   }
        // },
        // {
        //   "id": "147",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "6.03093",
        //     "lng": "-71.79845"
        //   }
        // },
        // {
        //   "id": "148",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "6.12199",
        //     "lng": "-71.71992"
        //   }
        // },
        // {
        //   "id": "149",
        //   "suceso": " OLEODUCTO",
        //   "puntos": {
        //     "lat": "6.17627",
        //     "lng": "-71.69111"
        //   }
        // },
        // // ______________________________________ OBC _______________________________
        
        {
          "id": "122",
          "suceso": " OLEODUCTO",
          "id_valv" : "CHEQUE NO. 1",
          "tipo" : "chequeo",
          "puntos": {
            "lat": "5.73654",
            "lng": "-71.89672"
          }
        },

        {
          "id": "122",
          "suceso": " OLEODUCTO",
          "id_valv" : "CHEQUE NO. 2",
          "tipo" : "chequeo",
          "puntos": {
            "lat": "5.78571",
            "lng": "-71.88506"
          }
      },

      {
        "id": "122",
        "suceso": " OLEODUCTO",
          "id_valv" : "CHEQUE NO. 3",
          "tipo" : "chequeo",
        "puntos": {
          "lat": "5.88404",
          "lng": "-71.85681"
        }
      },
      {
        "id": "122",
        "suceso": " OLEODUCTO",
        "id_valv" : "CHEQUE NO. 4",
        "tipo" : "chequeo",
        "puntos": {
          "lat": "6.29795",
          "lng": "-71.66688"
        }
      },
      {
        "id": "122",
        "suceso": " OLEODUCTO",
          "id_valv" : "CHEQUE NO. 5",
          "tipo" : "chequeo",
        "puntos": {
          "lat": "6.46160",
          "lng": "-71.65383"
        }
      },


        
        {
          "id": "150",
          "suceso": " OLEODUCTO",
          "id_valv" : "LV_40016",
          "puntos": {
            "lat": "6.20965",
            "lng": "-71.62131"
          }
        },
        {
          "id": "151",
          "suceso": " OLEODUCTO",
          "id_valv" : "LV_40017",
          "puntos": {
            "lat": "6.23979",
            "lng": "-71.62028"
          }
        },
        // {
        //   "id": "152",
        //   "suceso": " OLEODUCTO",
        //   "id_valv" : "LV_40018",
        //   "puntos": {
        //     "lat": "6.29795",
        //     "lng": "-71.66688"
        //   }
        // },
        {
          "id": "153",
          "suceso": " OLEODUCTO",
          "id_valv" : "LV_40019",
          "puntos": {
            "lat": "6.38608",
            "lng": "-71.68328"
          }
        },
        {
          "id": "154",
          "suceso": " OLEODUCTO",
          "id_valv" : "LV_40020",
          "puntos": {
            "lat": "6.40871",
            "lng": "-71.66533"
          }
        },
        // {
        //   "id": "155",
        //   "suceso": " OLEODUCTO",
        //   "id_valv" : "LV_40021",
        //   "puntos": {
        //     "lat": "6.46160",
        //     "lng": "-71.65383"
        //   }
        // },
        {
          "id": "156",
          "suceso": " OLEODUCTO",
          "id_valv" : "LV_40022",
          "puntos": {
            "lat": "6.50110",
            "lng": "-71.67006"
          }
        },
        {
          "id": "157",
          "suceso": " OLEODUCTO",
          "id_valv" : "LV_40023",
          "puntos": {
            "lat": "6.50110",
            "lng": "-71.67006"
          }
        },
        {
          "id": "158",
          "suceso": " OLEODUCTO",
          "id_valv" : "LV_40024",
          "puntos": {
            "lat": "6.50607",
            "lng": "-71.67322"
          }
        },
        {
          "id": "159",
          "suceso": " OLEODUCTO",
          "id_valv" : "LV_40025",
          "puntos": {
            "lat": "6.53821",
            "lng": "-71.66978"
          }
        },
        {
          "id": "160",
          "suceso": " OLEODUCTO",
          "id_valv" : "LV_40026",
          "puntos": {
            "lat": "6.55902",
            "lng": "-71.67972"
          }
        },
        {
          "id": "161",
          "suceso": " OLEODUCTO",
          "id_valv" : "LV_40027",
          "puntos": {
            "lat": "6.64485",
            "lng": "-71.70181"
          }
        },
        {
          "id": "162",
          "suceso": " OLEODUCTO",
          "id_valv" : "LV_40028",
          "puntos": {
            "lat": "6.68563",
            "lng": "-71.68531"
          }
        },
        {
          "id": "163",
          "suceso": " OLEODUCTO",
          "id_valv" : "LV_40029",
          "puntos": {
            "lat": "6.72035",
            "lng": "-71.68879"
          }
        },
        {
          "id": "164",
          "suceso": " OLEODUCTO",
          "id_valv" : "LV_40030",
          "puntos": {
            "lat": "6.85432",
            "lng": "-71.78120"
          }
        },
        {
          "id": "165",
          "suceso": " OLEODUCTO",
          "id_valv" : "LV_40031",
          "puntos": {
            "lat": "6.93065",
            "lng": "-71.78864"
          }
        }
      ]
    }
  ]